const REGULAR_MEMBER_TYPE   = 0;
const SHOP_MEMBER_TYPE     = 1;

export {REGULAR_MEMBER_TYPE,SHOP_MEMBER_TYPE}